<sd-dropdown
  [brand]="brand"
  [isBtnSmall]="isSmall"
  [isAutocomplete]="true"
  [type]="dropdownType"
  [clickToOpen]="false"
  [isSelected]="internalField.value"
  dropdownCustomClass="is-select-menu is-autocomplete"
  [(isOpened)]="isOpened"
  [focus]="false"
  (click)="setElementWidth()"
  (isOpenedChange)="isOpenedChange.emit($event)"
>
  <sd-form-input sd-dropdown-input
    #input
    autocomplete="off"
    [formControl]="inputControl"
    [(ngModel)]="inputValue"
    [labelTitle]="labelTitle"
    [placeholder]="placeholder"
    [nameField]="nameField"
    [labelHidden]="labelHidden"
    class="{{classField}}"
    type="search"
    (clear)="onClear()"
    [ngClass]="{'is-filled': inputValue, 'is-small': isSmall, 'is-open': isOpened}"
    [required]="false"
    [readonly]="readonly"
  />

  @if (_elements.length > 0 && !optionsAreCheckboxes && !isSelect) {
    <ul
      class="c__content {{isSmall ? 'is-small' : ''}}"
      sd-list-block
      sd-dropdown-menu
      sdUpDown
      role="listbox"
      [style.width]="elWidth +'px'"
    >
      @for (element of _elements; track element) {
        <li
          class="c__option"
          role="option"
          tabindex="1"
          (keydown.enter)="selectElement(element)"
          (click)="selectElement(element)"
        >
          @for (property of properties; track property) {
            <sd-html [html]="element[property]" [bold]="inputValue" tag="span" />
          }
        </li>
      }
    </ul>
  }
</sd-dropdown>

@if (_elements?.length > 0 && optionsAreCheckboxes && isSelect) {
  <sd-form checkbox-group
    class="c__content c__content-checkbox-group {{isSmall ? 'is-small' : ''}}"
    role="listbox"
    [brand]="brand"
    (checkedChange)="onChangeAutocompleteItems($event)"
    [groupLibelleTemplate]="libelleTemplate"
    customListClass="c__option"
    [nameField]="nameField"
    [labelTitle]="labelTitle"
    [labelHidden]="true"
    [items]="_elements"
  >
    <ng-template #libelleTemplate let-item="item">
      <ng-container *ngTemplateOutlet="groupLibelleTemplate; context: { item: item }" />
    </ng-template>
  </sd-form>
}

@if (_elements?.length > 0 && !optionsAreCheckboxes && isSelect && isDevice$) {
  <sd-form radio-group
    class="c__btn-group c__content c__content-radio-group"
    role="listbox"
    [required]="false"
    [nameField]="nameField"
    [labelHidden]="true"
    [labelTitle]="labelTitle"
    [items]="_elements"
    (valueChanged)="onChangeAutocompleteItems($event)"
  />
}

@if (_elements?.length > 0 && !optionsAreCheckboxes && isSelect && !isDevice$) {
  <ul
    class="c__content {{isSmall ? 'is-small' : ''}}"
    sd-list-block sd-dropdown-menu sdUpDown
    role="listbox"
  >
    @for (item of _elements; track item) {
      <li class="c__option"
        [attr.tabindex]="'1'"
        role="option"
        [attr.data-value]="item[valueKey]"
        [attr.aria-selected]="item[libelleKey] === libelle"
        (keydown.enter)="itemClickSelected(item)"
        (click)="itemClickSelected(item)"
      >
        {{ item[libelleKey] }}
      </li>
    }
  </ul>
}

<ng-content select="[sd-message]" />
